import { useCrudSections } from '@/modules/templates/hooks/useSections';
import { CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.less';
import { useRunAuditOnlineStatus } from '@/contexts/RunAuditOnlineStatusProvider';

const MobileSectionTitleAction = ({ sectionId, duplicable, isDuplicated }) => {
  const { t } = useTranslation('templates');
  const { online } = useRunAuditOnlineStatus();
  const { duplicate, isDuplicating, remove, isRemoving } = useCrudSections();

  const onDuplicate = useCallback(async () => {
    await duplicate({ sectionId, isNewDuplicate: true });
  }, [duplicate, sectionId]);

  const onRemoveDuplicatedSection = useCallback(async () => {
    await remove(sectionId);
  }, [remove, sectionId]);

  return (<>
    { duplicable && (
      <div>
        <Tooltip title={ t('duplicable') }>
          <Button
            type="dashed"
            disabled={ isDuplicating || !online}
            loading={ isDuplicating }
            onClick={ onDuplicate }
            className={ classNames(styles.duplicableButton) }
            style={ { background: 'transparent', color: '#fff' } }
            icon={ <CopyOutlined /> }
          />
        </Tooltip>
      </div>
    ) }
    { isDuplicated && (
      <div>
        <Tooltip title={ t('removeDuplicated') }>
          <Button
            type="dashed"
            disabled={ isRemoving || !online }
            loading={ isRemoving }
            onClick={ onRemoveDuplicatedSection }
            className={ classNames(styles.removeDuplicatedButton) }
            style={ { background: 'transparent', color: '#fff' } }
            icon={ <DeleteOutlined /> }
          />
        </Tooltip>
      </div>
    ) }
  </>);
};

MobileSectionTitleAction.propTypes = {
  sectionId: PropTypes.string,
  duplicable: PropTypes.bool,
  isDuplicated: PropTypes.bool
};

export default memo(MobileSectionTitleAction);
